module.exports = __webpack_public_path__ + "static/media/friends.34b890ab.png";